<!--
 * @Author: zhangzhian@linshimuye.com
 * @Date: 2022-12-01 18:08:56
 * @LastEditors: zhangzhian@linshimuye.com
 * @LastEditTime: 2022-12-13 16:23:57
 * @FilePath: \dhr_frontend\src\components\LinSpin\index.vue
 * @Description: loading加载组件
 * @ImportRoute: import LinSpin from '@/components/LinSpin/index.vue'
-->
<template>
  <div class="lin-spin" v-show="loading">
    <a-spin v-bind="$attrs" v-on="$listeners" />
  </div>
</template>
<script>
export default {
  name: 'lin-spin',
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.lin-spin {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  height: 100%;
  width: 100%;
  background-color: hsla(0, 0%, 100%, 0.7);
}
</style>
